import React, { Component, Fragment } from "react"

import { withAuth0 } from "@auth0/auth0-react"
import Alert from "react-bootstrap/Alert"
import Button from "react-bootstrap/Button"
import Form from "react-bootstrap/Form"
import { FormattedMessage } from "react-intl"

import Space from "./space"

class IdentityMfa extends React.Component {
  constructor(props) {
    super(props)
    this.handleStartSetup = this.handleStartSetup.bind(this)
    this.handleVerify = this.handleVerify.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.state = {
      status: "view",
      mfaStatus: this.props.identity.mfaStatus,
      mfaEnrolledAt: this.props.identity.mfaEnrolledAt,
      qrCodeUrl: null,
      verificationCode: "",
      alert: null,
    }
  }

  handleInputChange(e) {
    const target = e.target
    const name = target.name
    const value = target.type === "checkbox" ? target.checked : target.value

    this.setState({ [name]: value })
  }

  handleStartSetup(e) {
    e.preventDefault()
    this.setState(
      {
        status: "start_setup",
        alert: null,
      },
      () => {
        this.props.auth0
          .getAccessTokenSilently({
            audience: process.env.GATSBY_AUTH0_AUDIENCE,
            scope: process.env.GATSBY_AUTH0_SCOPE,
          })
          .then(accessToken => {
            const url = new URL(
              "/identity/startMfaSetup",
              process.env.GATSBY_API_URL
            )
            const params = {}
            Object.keys(params).forEach(key =>
              url.searchParams.append(key, params[key])
            )
            fetch(url, {
              method: "POST",
              headers: { Authorization: `Bearer ${accessToken}` },
            })
              .then(response => {
                if (response.ok) {
                  response.blob().then(blob => {
                    const qrUrl = URL.createObjectURL(blob)
                    this.setState({
                      status: "view",
                      mfaStatus: "Verifying",
                      qrCodeUrl: qrUrl,
                    })
                  })
                } else {
                  response.text().then(text => {
                    this.setState({
                      status: "view",
                      alert: text,
                    })
                  })
                }
              })
              .catch(error => {
                this.setState({
                  status: "view",
                  alert: error.message,
                })
              })
          })
      }
    )
  }

  handleVerify(e) {
    e.preventDefault()
    this.setState(
      {
        status: "verify",
        alert: null,
      },
      () => {
        this.props.auth0
          .getAccessTokenSilently({
            audience: process.env.GATSBY_AUTH0_AUDIENCE,
            scope: process.env.GATSBY_AUTH0_SCOPE,
          })
          .then(accessToken => {
            const url = new URL(
              "/identity/verifyMfaSetup",
              process.env.GATSBY_API_URL
            )
            const params = {}
            params.code = this.state.verificationCode
            Object.keys(params).forEach(key =>
              url.searchParams.append(key, params[key])
            )
            fetch(url, {
              method: "POST",
              headers: { Authorization: `Bearer ${accessToken}` },
            })
              .then(response => {
                if (response.ok) {
                  response.text().then(text => {
                    this.setState({
                      status: "view",
                      mfaStatus: "Verified",
                      qrCodeUrl: null,
                      verificationCode: "",
                    })
                  })
                } else {
                  response.text().then(text => {
                    this.setState({
                      status: "view",
                      alert: text,
                    })
                  })
                }
              })
              .catch(error => {
                this.setState({
                  status: "view",
                  alert: error.message,
                })
              })
          })
      }
    )
  }

  render() {
    return (
      <>
        {(this.state.mfaStatus == "New" || this.state.mfaStatus == "Ready") && (
          <Alert variant="info">
            <FormattedMessage id={"MFA.Setup Instructions"} />
          </Alert>
        )}
        {this.state.mfaStatus == "Verifying" && !this.state.qrCodeUrl && (
          <Alert variant="warning">
            <FormattedMessage id={"MFA.Setup In Progress"} />
          </Alert>
        )}
        {this.state.mfaStatus == "Verified" && (
          <Alert variant="info">
            <FormattedMessage id={"MFA.Enabled Message"} />
            {this.state.mfaEnrolledAt && (
              <>
                {" "}
                <FormattedMessage id={"MFA.Enrolled At"} />:{" "}
                {this.state.mfaEnrolledAt}
              </>
            )}
          </Alert>
        )}
        {this.state.mfaStatus == "Not Verified" && (
          <Alert variant="info">
            <FormattedMessage id={"MFA.Setup Instructions"} />
          </Alert>
        )}
        {this.state.alert != null && (
          <Alert variant="danger">
            <FormattedMessage id={this.state.alert} />
          </Alert>
        )}
        {this.state.qrCodeUrl && (
          <>
            <Alert variant="info">
              <FormattedMessage id={"MFA.QR Code Instructions"} />
            </Alert>
            <div className="mb-3 text-center">
              <img
                src={this.state.qrCodeUrl}
                alt="MFA QR Code"
                style={{ maxWidth: "300px" }}
              />
            </div>
          </>
        )}
        <Form>
          {this.state.qrCodeUrl && (
            <Form.Group>
              <Form.Label>
                <FormattedMessage id={"MFA.Verification Code Label"} />
              </Form.Label>
              <Form.Control
                name="verificationCode"
                type="text"
                value={this.state.verificationCode}
                disabled={this.state.status != "view"}
                onChange={this.handleInputChange}
                placeholder="000000"
                maxLength={6}
                pattern="[0-9]{6}"
              />
              <Form.Text className="text-muted">
                <FormattedMessage id={"MFA.Verification Code Hint"} />
              </Form.Text>
            </Form.Group>
          )}
          {this.state.status == "view" &&
            (this.state.mfaStatus == "New" || this.state.mfaStatus == "Ready") && (
              <>
                <Button variant="primary" onClick={this.handleStartSetup}>
                  <FormattedMessage id={"MFA.Start Setup Button"} />
                </Button>
              </>
            )}
          {this.state.status == "start_setup" && (
            <>
              <Button variant="primary" disabled>
                <FormattedMessage id={"MFA.Start Setup Button"} />
              </Button>
            </>
          )}
          {this.state.status == "view" &&
            this.state.mfaStatus == "Verifying" &&
            !this.state.qrCodeUrl && (
              <>
                <Button variant="primary" onClick={this.handleStartSetup}>
                  <FormattedMessage id={"MFA.Continue Setup Button"} />
                </Button>
              </>
            )}
          {this.state.status == "view" &&
            this.state.mfaStatus == "Verifying" &&
            this.state.qrCodeUrl && (
              <>
                <Button
                  variant="warning"
                  onClick={this.handleVerify}
                  disabled={this.state.verificationCode.length !== 6}
                >
                  <FormattedMessage id={"MFA.Verify Button"} />
                </Button>
              </>
            )}
          {this.state.status == "verify" && (
            <>
              <Button variant="warning" disabled>
                <FormattedMessage id={"MFA.Verify Button"} />
              </Button>
            </>
          )}
          {this.state.status == "view" && this.state.mfaStatus == "Verified" && (
            <>
              <Button variant="primary" disabled>
                <FormattedMessage id={"MFA.Start Setup Button"} />
              </Button>
            </>
          )}
          {this.state.status == "view" &&
            this.state.mfaStatus == "Not Verified" && (
              <>
                <Button variant="primary" disabled>
                  <FormattedMessage id={"MFA.Start Setup Button"} />
                </Button>
              </>
            )}
        </Form>
      </>
    )
  }
}

export default withAuth0(IdentityMfa)
